import apiClient from './apiClient';

export const getCourses = () => {
  return apiClient('/courses');
};

export const createCourse = (data) => {
  return apiClient('/courses', {
    method: 'POST',
    body: data,
  });
};

export const getCourse = (id) => {
  return apiClient(`/courses/${id}`);
};

export const updateCourse = (id, data) => {
  return apiClient(`/courses/${id}`, {
    method: 'PUT',
    body: data,
  });
};

export const deleteCourse = (id) => {
  return apiClient(`/courses/${id}`, {
    method: 'DELETE',
  });
}; 